import PinkContentBox from './PinkContentBox';

export default PinkContentBox;
